import { Component, OnInit } from '@angular/core';
import {environment} from '../../environments/environment';
import {ConfService} from '../conf.service';
import {interval} from 'rxjs';
import {LeftpanelComponent, LoaderWithProgressComponent} from '../leftpanel/leftpanel.component';
import { Router } from '@angular/router';
import {MatDialog} from '@angular/material';
import {BusinessLogicDataService} from '../new-blockly/business-logic-data.service';
import {AccountInfoService} from '../user/account-info.service';

@Component({
  selector: 'ap-accelerators',
  templateUrl: './accelerators.component.html',
  styleUrls: ['./accelerators.component.scss']
})
export class AcceleratorsComponent implements OnInit {

  partner = localStorage.getItem('partner');
  account = localStorage.getItem('account');

  acceleratorList = [];

  componentLoading = true;
  dataLoading = true;
  errorOccured = false;
  errorMessage = '';

  viewPermission = false;

  constructor(private confSrv: ConfService,
              public platform: LeftpanelComponent,
              private router: Router,
              public accountInfoService: AccountInfoService,
              private businessLogicDataService: BusinessLogicDataService,
              public dialog: MatDialog) { }

  ngOnInit() {
    if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
      this.platform.initialisePlatform();
    }

    const permissionSubscription = interval(500).subscribe((async x => {
      if (this.accountInfoService.hasPermissionsLoaded()) {
        permissionSubscription.unsubscribe();
        this.viewPermission = this.platform.hasPlatformPermission('VIEW_ACCELERATORS');
        if (this.viewPermission) {
          Promise.resolve(this.retrieveData()).then(async resp1 => {
            this.componentLoading = false;
          }, error => {

          });
        } else {
          this.componentLoading = false;
        }
      }
    }));
  }

  handleToggle(isEnabled: any, integration_title: any) {
    this.businessLogicDataService.acceleratorsForceFetchNextCall = true;
    if (isEnabled) {
      this.handleDisable(integration_title);
    } else {

      this.handleEnable(integration_title);
    }
  }

  handleEnable(integration_title: any) {
    return new Promise((resolve, reject) => {
      this.dataLoading = true;
      this.errorOccured = false;
      const payload = {
        significance: 'generate',
        intent: 'subscriptions',
        partner: this.partner,
        account: this.account,
        data: {
          integration: integration_title,
          enabled: true
        }
      };
      const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
        width: 'auto',
        height: 'auto',
      });
      this.confSrv.postIntegrationsApi(environment.integrationsAPI.accelerators.name, environment.integrationsAPI.accelerators.version, payload).subscribe(data => {
        this.redirect('/accelerator/' + integration_title);
        loaderDialog.close();
        resolve();
      }, error => {
        loaderDialog.close();
        reject('Toggle Failed');
      });
    });
  }

  handleDisable(integration_title: any) {
    return new Promise((resolve, reject) => {
      this.dataLoading = true;
      this.errorOccured = false;
      const payload = {
        significance: 'generate',
        intent: 'subscriptions',
        partner: this.partner,
        account: this.account,
        data: {
          integration: integration_title,
          enabled: false
        }
      };
      this.confSrv.postIntegrationsApi(environment.integrationsAPI.accelerators.name, environment.integrationsAPI.accelerators.version, payload).subscribe(data => {
        resolve();
      }, error => {
        reject('Toggle Failed');
      });
    });
  }

  redirect(path: any) {
    this.router.navigate([path], {
      queryParams: {
        selectedIndex: 1,
      },
    });
  }

  retrieveData() {
    return new Promise((resolve, reject) => {
      this.dataLoading = true;
      this.errorOccured = false;
      const payload = {
        significance: 'compose',
        intent: 'integrations',
        partner: this.partner,
        account: this.account
      };
      this.confSrv.postIntegrationsApi(environment.integrationsAPI.accelerators.name, environment.integrationsAPI.accelerators.version, payload).subscribe(data => {
        let resp: any;
        resp = data;
        this.acceleratorList = resp['item'];
        this.dataLoading = false;
        resolve();
      }, error => {
        this.errorOccured = true;
        this.dataLoading = false;
        reject('Unable to load data');
      });
    });
  }

}
